import styled from "styled-components";

export const WrapperItems = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
